/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2015, 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Events',
	'../../filters/VisFilterProxy',
	'underscore'
], function(Events, VisFilterProxy, _) {
	'use strict';
	/**
	 * 'FilterSelectedBaseAction' is the base class of FilterLocalKeepSelected, FilterLocalExcludeSelected
	 * and FilterAllKeepSelected actions.
	 *
	 * User selections are built by the user as 'pending filters' usually as a form of multiselect
	 * (using the ctrl/command key or longpress).
	 *
	 * Pressing the filter button transfers these filters from pending to actual.
	 */
	var FilterSelectedBaseAction = null;

	FilterSelectedBaseAction = Events.extend({
		init: function(visModel, pageContext, logger) {
			FilterSelectedBaseAction.inherited('init', this, arguments);
			this.visModel	= visModel;
			this.localFilters = visModel.localFilters;
			this.pageContext=pageContext;
			this.toolbarContribution = [];
			this.logger = logger;
		},

		//NOTE: getActionId() must be implemented in derived classes!

		/**
		 * get the set of availableSort actions setting the selected state to match
		 * the state of the data (toolbarContribution must be overriden in derived classes).
		 * @returns the sort actions and their state.
		 */
		getAvailableActions: function() {
			return this.toolbarContribution;
		},

		/**
		 * Apply each filter and pendingFilter to an 'targetFiltersObject' (which is either the
		 * local or widget-level filter objects).  If operator is set, make sure the
		 * actualFilter object uses this operator rather than 'in'.
		 *
		 * @param targetFiltersObject The 'target' being either local or widget level filters
		 * @param operator (optional) Defines the operator for the targetFiltersObject (usu notin or in)
		 * @param options - when this action is part of a larger transaction, this can be specified....otherwise, the filter change is assumed to be atomic.
		 * @param toEdgeFilters - a flag to indicate whether to change data point filters to edge filters
		 * @returns the set of filters which were collected to add to local filters.
		 */
		_applyAllFilters: function(targetFiltersObject, operator, options, toEdgeFilters) {
			//Convert all visible highlighted selections or pending selections to local filters.
			var isExcludeFilter=(operator==='notin') ? true : false;
			var itemContext = this.getItemContext();

			var visFilterProxy = new VisFilterProxy(
				{
					input: this.pageContext,
					output: targetFiltersObject,
					selectors: itemContext,
					exclude: isExcludeFilter,	//Set the polarity based on the operation (keep/Exclude)
					action: 'keepexclude',
					toEdgeFilters: toEdgeFilters,
					logger: this.logger
				}
			);

			if (this.pageContext===targetFiltersObject || !visFilterProxy.convertFilters(/*slotsToClear*/null, options)) {
				//In the case where there are no selections (ie: a right click only),
				//use the pending filters.
				//TODO: Perhaps pending and selections should be merged?
				if (this.visModel.getPendingFilters()) {
					visFilterProxy.input=this.visModel.getPendingFilters();
					visFilterProxy.convertFilters(/*slotsToClear*/null, options);
				}
			}

			if (isExcludeFilter) {
				//Clear brushing in other widgets when operator is exclude (need to set silent to false).
				var clearBrushingOptions=_.clone(options);
				clearBrushingOptions.silent=false;
				visFilterProxy.setOutput(this.pageContext);
				visFilterProxy.removeFilterValues(itemContext, clearBrushingOptions);
			}

			this.visModel.setPendingFilters(false);

			return visFilterProxy;
		},

		getItemContext: function() {
			return {
				origin: 'visualization',
				sourceId: this.visModel.getModule().getSourceId(),
				scope: this.visModel.getScope(),
				eventGroupId: this.visModel.getEventGroupId(),
				//use the 'strict match option' and event source to only select brushing entries
				//that originate from this visualization.
				eventSourceId: this.visModel.getWidgetId(),
				_strictMatch: true
			};
		}

	});

	return FilterSelectedBaseAction;

});
